import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "d-flex p-4 border-secondary bg-white border rounded gap-4 align-items-center mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-fill fs-2x text-info" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "m-0" }, "Cierre de inscripción en: ", -1)
const _hoisted_7 = {
  key: 0,
  class: "dialog-footer"
}
const _hoisted_8 = { class: "me-2 fw-bold" }
const _hoisted_9 = {
  key: 1,
  class: "dialog-footer"
}
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_Form1 = _resolveComponent("Form1")!
  const _component_Form2 = _resolveComponent("Form2")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "General Entry Form",
    modelValue: _ctx.dialogForm,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogForm) = $event)),
    "close-on-click-modal": false,
    class: "bg-custom rounded mb-0",
    top: "1vh",
    width: "60%",
    onOpen: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "show-close": false
  }, _createSlots({
    header: _withCtx(({ close, titleId }) => [
      _createElementVNode("div", {
        id: titleId,
        class: "d-flex align-items-start justify-content-between"
      }, [
        _createElementVNode("h2", {
          class: "card-label font-weight-bolder text-dark m-0",
          textContent: _toDisplayString(_ctx.itemForm?.form_name)
        }, null, 8, _hoisted_2),
        _createElementVNode("i", {
          class: "bi bi-x-lg fs-1 cursor-pointer text-black text-hover-danger",
          onClick: close
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
        ref: "scrollbarRef",
        height: `${_ctx.altura - 315}px`,
        always: "",
        class: "form-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            (_ctx.itemForm)
              ? (_openBlock(), _createBlock(_component_CountDown, {
                  key: 0,
                  fechafin: _ctx.itemForm.end_date,
                  "class-name": "text-center h5 fw-bolder mb-0 text-info",
                  "class-text": "mb-0 fw-bolder",
                  subtitle: "font-size:10px;",
                  onChangeStatus: _ctx.changeStatus
                }, null, 8, ["fechafin", "onChangeStatus"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.idForm == 1)
            ? (_openBlock(), _createBlock(_component_Form1, {
                key: 0,
                ref: "childComponentRef",
                idevent: _ctx.idevent,
                onFormLoaded: _ctx.onFormLoaded
              }, null, 8, ["idevent", "onFormLoaded"]))
            : _createCommentVNode("", true),
          (_ctx.idForm == 2)
            ? (_openBlock(), _createBlock(_component_Form2, {
                key: 1,
                ref: "childComponentRef",
                idevent: _ctx.idevent,
                onFormLoaded: _ctx.onFormLoaded
              }, null, 8, ["idevent", "onFormLoaded"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["height"])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 2
  }, [
    (_ctx.childComponentRef)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            (_ctx.isAdminn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t('state')), 1),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.childComponentRef.formQ.mstatus,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.childComponentRef.formQ.mstatus) = $event)),
                    placeholder: _ctx.t('seleccione'),
                    class: "w-200px me-4",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.name,
                          value: item.id,
                          key: `lst-s-${index}`
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAdmin()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("save")), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_loading, !_ctx.isFormLoaded]
                  ]),
                  _createVNode(_component_el_button, {
                    color: "#E71D2E",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogForm = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("close")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (!_ctx.formExpired)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.childComponentRef?.formQ.mstatus == 4)
                          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveAsDraf()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("save2")), 1)
                              ]),
                              _: 1
                            })), [
                              [_directive_loading, !_ctx.isFormLoaded]
                            ])
                          : _createCommentVNode("", true),
                        (_ctx.childComponentRef?.formQ.mstatus == 4)
                          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "primary",
                              disabled: !_ctx.isFormLoaded,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveAndSend()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("save1")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])), [
                              [_directive_loading, !_ctx.isFormLoaded]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          color: "#E71D2E",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogForm = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString((_ctx.childComponentRef?.formQ.mstatus == 4) ? _ctx.t("cancel") : _ctx.t("close")), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        color: "#E71D2E",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogForm = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("close")), 1)
                        ]),
                        _: 1
                      }))
                ]))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "onOpen", "onClosed"]))
}